import { CountryPrefix } from 'Jsx/global';

import { Validation } from '../../InputField';

const argentinaValidation: Validation = ({ rawValue }) => {
  if (rawValue.length === 0)
    return {
      isValid: false,
      errorMessage: 'El número de documento es obligatorio.',
    };

  if (rawValue.length < 7) {
    return {
      isValid: false,
      errorMessage: 'El número de documento debe tener al menos 7 dígitos.',
    };
  }
  return { isValid: true, errorMessage: '' };
};

const peruValidation: Validation = ({ rawValue }) => {
  if (rawValue.length === 0)
    return {
      isValid: false,
      errorMessage: 'El número de documento es obligatorio.',
    };

  if (rawValue.length !== 8) {
    return {
      isValid: false,
      errorMessage: 'El número de documento debe tener 8 dígitos.',
    };
  }
  return { isValid: true, errorMessage: '' };
};

const isCPFAlgorithmValid = (cpf: string): boolean => {
  let number: any;
  let digits;
  let sum = 0;
  let i;
  let result;
  let equalDigits;

  equalDigits = 1;
  for (i = 0; i < cpf.length - 1; i += 1)
    if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
      equalDigits = 0;
      break;
    }
  if (!equalDigits) {
    number = cpf.substring(0, 9);
    digits = cpf.substring(9);
    sum = 0;
    for (i = 10; i > 1; i -= 1) sum += number.charAt(10 - i) * i;
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0), 10)) return false;
    number = cpf.substring(0, 10);
    sum = 0;
    for (i = 11; i > 1; i -= 1) sum += number.charAt(11 - i) * i;
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1), 10)) return false;
    return true;
  }
  return false;
};

const brasilValidation: Validation = ({ rawValue }) => {
  if (rawValue.length === 0)
    return {
      isValid: false,
      errorMessage: 'O Cadastro de Pessoas Físicas é obrigatório.',
    };

  if (rawValue.length !== 11) {
    return {
      isValid: false,
      errorMessage: 'O Cadastro de Pessoas Físicas deve ter 11 dígitos.',
    };
  }

  if (!isCPFAlgorithmValid(rawValue)) {
    return {
      isValid: false,
      errorMessage: 'O Cadastro de Pessoas Físicas es invalido.',
    };
  }

  return { isValid: true, errorMessage: '' };
};

const colombiaValidation: Validation = ({ rawValue }) => {
  if (rawValue.length === 0)
    return {
      isValid: false,
      errorMessage: 'El documento de identidad es obligatorio.',
    };

  if (rawValue.length < 9) {
    return {
      isValid: false,
      errorMessage: 'El documento de identidad debe tener al menos 9 dígitos.',
    };
  }
  return { isValid: true, errorMessage: '' };
};

const mexicoValidation: Validation = ({ rawValue }) => {
  if (rawValue.length === 0)
    return {
      isValid: false,
      errorMessage: 'La Clave Única del Registro de Población es obligatoria.',
    };

  if (rawValue.length !== 18) {
    return {
      isValid: false,
      errorMessage:
        'La Clave Única del Registro de Población debe tener 18 caracteres.',
    };
  }
  return { isValid: true, errorMessage: '' };
};

const defaultValidation: Validation = ({ rawValue }) => {
  if (rawValue.length === 0)
    return {
      isValid: false,
      errorMessage: 'El número de documento es obligatorio.',
    };
  if (rawValue.length < 7) {
    return {
      isValid: false,
      errorMessage: 'El número de documento debe tener al menos 7 dígitos',
    };
  }
  return { isValid: true, errorMessage: '' };
};

export const getValidation = (countryPrefix: CountryPrefix): Validation => {
  switch (countryPrefix) {
    case 'ar':
      return argentinaValidation;
    case 'pe':
      return peruValidation;
    case 'br':
      return brasilValidation;
    case 'co':
      return colombiaValidation;
    case 'mx':
      return mexicoValidation;
    default:
      return defaultValidation;
  }
};
